import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue';
import routes from './routes/routes.js';

const router = createRouter({
    history: createWebHistory(),
    base: process.env.BASE_URL,
    routes,
});
const app = createApp(App);
app.use(router);
app.mount('#app');
